<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="3" class="pt-0 pb-3">
                <list-storehouses></list-storehouses>
            </v-col>
            <v-col cols="9" class="pt-0 pb-3">
                <detail-storehouse></detail-storehouse>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import ListStorehouses from '../../components/Storehouses/ListStorehouses'
import DetailStorehouse from '../../components/Storehouses/DetailStorehouse'

export default {
    name: 'Storehouse',
    components: {
        ListStorehouses,
        DetailStorehouse
    }
}
</script>

<style>

</style>